/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: ISOSizeSelect.tsx
 * Project: mle-client-n
 * Committed last: 2022/11/22 @ 1628
 * ---
 * Description:
 */

import {MleCustomSelect} from "../common/MleCustomSelect";
import {pixelToMeasureUnit} from "../../../../common/measure-unit-utils";
import {IsoSizes, isoSizesPixelDimensions} from "../../../../common/project";
import {objectToSelectItemsArray} from "../../../../common/utils";
import {MeasureUnits} from "../../../../common/enums";
import {StyleableComponent} from "../../../common/props/StyleableComponent";
import {Intent} from "@blueprintjs/core";

interface Props extends StyleableComponent {
    measureUnit: MeasureUnits;
    onSizeSelect: (size: IsoSizes) => void;
    initialValue?: IsoSizes;
    intent?: Intent;
}

/**
 * Componente per selezionare le dimensioni predefinite dell'etichetta
 * @param props
 * @constructor
 */
export const ISOSizeSelect = (props: Props) => {
    return (
        <MleCustomSelect<any>
            intent={props.intent}
            className={"w-full" + props.className}
            name="colorProfile"
            icon="document"
            renderText={item => item.name}
            renderLabel={item => {
                const convertedWidth = pixelToMeasureUnit(props.measureUnit,
                    isoSizesPixelDimensions[item.value as IsoSizes].width);
                const convertedHeight = pixelToMeasureUnit(props.measureUnit,
                    isoSizesPixelDimensions[item.value as IsoSizes].height);
                return `${convertedWidth}x${convertedHeight}${props.measureUnit}`;
            }}
            initalValue={props.initialValue || {name: '(effettua selezione)'}}
            items={objectToSelectItemsArray(IsoSizes)}
            onSelect={props.onSizeSelect}
        />
    )
}